import { render } from "./PerfilFicha.vue?vue&type=template&id=1a5b347c"
import script from "./PerfilFicha.vue?vue&type=script&lang=ts"
export * from "./PerfilFicha.vue?vue&type=script&lang=ts"
script.render = render

export default script